import { isNull } from "lodash";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DeviceTabContentWrapper from "@/shared/widgets/DeviceTabContentWrapper";
import useTransportWarehouseCacheData from "@/domains/transportWarehouse/hooks/useTransportWarehouseCacheData";
import TransportWarehouseInfoCapacity from "@/domains/transportWarehouse/components/info/TransportWarehouseInfoCapacity";

// import TransportWarehouseInfoRepair from "@/domains/transportWarehouse/components/info/TransportWarehouseInfoRepair";
// import TransportWarehouseInfoSize from "@/domains/transportWarehouse/components/info/TransportWarehouseInfoSize";

type Props = {
  isFirstRender?: boolean;
};

export default function TransportWarehouseInfoContainer({ isFirstRender }: Props) {
  const { t } = useTranslation("transportWarehouse");
  const { transportWarehouseInfo } = useTransportWarehouseCacheData();

  const footer = (
    <div>
      <div className="text-16 font-bold">{t("transportWarehouse.additionalInfo")}</div>
      <ul className="mt-2">
        {(t("transportWarehouse.additionalTips", { returnObjects: true }) as string[]).map(
          (item) => (
            <li key={item} className="list-disc text-15 font-medium text-white/30 ml-5 py-1">
              {item}
            </li>
          ),
        )}
      </ul>
    </div>
  );

  const availiable = useMemo(
    () =>
      transportWarehouseInfo
        ? transportWarehouseInfo.vehicles.filter((item) => !isNull(item)).length
        : 0,
    [transportWarehouseInfo],
  );

  if (!transportWarehouseInfo) {
    return null;
  }

  return (
    <DeviceTabContentWrapper
      header={t("transportWarehouse.warehouseInfo")}
      isStaticFirst={isFirstRender}
      className="p-0"
      footer={footer}
    >
      <div className="grid grid-cols-2 gap-3.5">
        <TransportWarehouseInfoCapacity
          availiable={availiable}
          totalAvailiable={transportWarehouseInfo.capacity}
        />
        {/* <TransportWarehouseInfoSize sizeType={t("transportWarehouse.small")} />
        <TransportWarehouseInfoRepair repairType={t("transportWarehouse.luxary")} /> */}
      </div>
    </DeviceTabContentWrapper>
  );
}
